<template>
  <div class="app-wrapper">
    <div class="main-container">
      <NavBar />
      <section class="app-main">
        <div class="app-scrollbar" ref="appScrollbar">
          <slot></slot>
          <Footer></Footer>
        </div>
        <!-- 右下角功能提示帮助 -->
        <PageHelp></PageHelp>
      </section>
    </div>
  </div>
</template>

<script lang="ts" setup>
import NavBar from "./NavBar.vue";
import Footer from "./Footer.vue";
import PageHelp from "~/components/PageHelp.vue";
import { nextTick, ref, watch } from "vue";
const appScrollbar = ref<HTMLElement | null>(null);
const router = useRouter();
watch(
  () => router.currentRoute.value,
  (_newValue: any) => {
    nextTick(() => {
      appScrollbar.value?.scrollTo(0, 0);
    });
  },
  { immediate: true }
);
</script>

<style scoped lang="scss">
@use "~/assets/styles/mixins.scss";
.app-wrapper {
  position: relative;
  width: 100%;

  // &::after {
  //   content: "";
  //   display: table;
  //   clear: both;
  // }

  .sidebar-container {
    background-color: var(--sidebar-menu-bg-color);
    width: var(--sidebar-width) !important;
    height: 100%;
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    z-index: 1001;
    overflow: hidden;
  }

  .main-container {
    min-height: 100%;
    margin-left: var(--sidebar-width);
    position: relative;
  }
}

.app-main {
  padding-top: var(--header-height);
  height: 100vh;
  width: 100%;
  overflow: auto;
  position: relative;
  display: flex;

  .app-scrollbar {
    // 注释flex-grow: 1; 使得内容区域不会被撑满
    flex-grow: 1;
    overflow: auto;
    @extend %scrollbar;
  }
}
</style>
